<template>
  <div class="title">{{ navtitle }}</div>
</template>

<script>
export default {
  props: {
    navtitle: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 90%;
  height: 40px;
  position: relative;
  left: 10px;
  color: white;
  padding-left: 20px;
  font-size: 18px;
  line-height: 40px;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  background-color: #042143;
  margin-left: 15px;
  text-shadow: 0 0 0.3rem #042143;
}
.title:before {
  width: 5px;
  height: 40px;
  top: 0px;
  left: -10px;
  position: absolute;
  content: "";
  background: #1b7ef2;
}
</style>